const STORE_PREFIX = 'polln';

const storage = {
  setItem: (name: string, token: string) => localStorage.setItem(`${STORE_PREFIX}-${name}`, token),
  getItem: (name: string) => localStorage.getItem(`${STORE_PREFIX}-${name}`),
  removeItem: (name: string) => localStorage.removeItem(`${STORE_PREFIX}-${name}`)
};

export default storage;
